import Advertise from "./Advertise";
import "./Css/GameSidebar.css"; // Adjust the path as necessary
const AdvertisementRight = () => {
  return (
    <>
      <div className={`sidebar-right sidebar_mobile`}>
        <h4 className="ad-title"> Advertisement</h4>
        <Advertise slot="3925023209" width="auto" />
      </div>
    </>
  );
};

export default AdvertisementRight;
